export enum OperationPopoverFields {
  OriginId = 'originId',
  ImportJobName = 'importJobName',
  ExportJobName = 'exportJobName',
  JobId = 'jobId',
  Destination = 'destination',
  DestinationUrl = 'destinationUrl',
  JobScheduleId = 'jobScheduleId',
  JobSchedule = 'jobSchedule',
  ScheduleStart = 'scheduleStart',
  ScheduleEnd = 'scheduleEnd',
  Source = 'source',
  SourceUrl = 'sourceUrl',
  SourceId = 'sourceId',
  DestinationId = 'destinationId',
  Type = 'type'
}
